import { cn } from '@/lib/utils';
import type { RecentActivityItem } from '../types';

interface RecentActivityProps {
	items: RecentActivityItem[];
}

export function RecentActivity({ items }: RecentActivityProps) {
	return (
		<div className="space-y-1">
			{items.map((item, i) => (
				<div
					key={i}
					className="flex items-center gap-3 rounded px-2 py-1.5 text-xs hover:bg-muted/50"
				>
					<span className="w-14 shrink-0 text-muted-foreground">
						{item.time}
					</span>
					<span className="font-medium">{item.event}</span>
					<span
						className={cn(
							'rounded px-1.5 py-0.5 text-[10px] font-medium',
							item.status === 'ok'
								? 'bg-green-100 text-green-700'
								: 'bg-red-100 text-red-700',
						)}
					>
						{item.action}
					</span>
					<span className="text-muted-foreground">{item.channel}</span>
					<span className="text-muted-foreground">{item.client}</span>
					<span className="ml-auto tabular-nums text-muted-foreground">
						{item.count.toLocaleString()}
					</span>
				</div>
			))}
		</div>
	);
}
